<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')" class="pdf color-text2">
		<el-form label-position="left" label-width="140px">
			<el-form-item label="故事名稱">
				<p class="color-danger" v-if="!editStoryData.story_name">尚未填寫</p>
				<p class="color-black" v-else>{{editStoryData.story_name}}</p>
			</el-form-item>
			<el-form-item label="DFC四步驟學習單">
				<div class="row" gutter="20">
					<el-button v-if="previewURL" @click="dialogVisible = true" type="text">點選預覽</el-button>
					<div v-else class="color-danger">尚未上傳</div>
				</div>
			</el-form-item>
		</el-form>
		<div>*空白DFC四步驟學習單請
			<a href="https://drive.google.com/file/d/1erVMeoIAGkDLHBqEvdx9MezBsgNrIDMs/view?usp=sharing" :download="`${transformStoryAccount(editStoryData.account)}-${editStoryData.story_name}-2.3_步驟_小學生公益行動_DFC_挑戰_學習單.docx`" target="_blank" class="color-blue1">由此</a>
			下載
		</div>
		<div class="tips">*請上傳PDF檔案，可以看到
			<a href="https://sofree.cc/word-convert-pdf" target="_blank" class="color-blue1">如何將Word檔案另存成PDF檔</a>
		</div>
		<el-dialog :visible.sync="dialogVisible">
			<iframe :src="previewURL | httpsFilter" frameborder="0" width="100%" height="500px"></iframe>
		</el-dialog>
	</brows-layout>
</template>

<script>
import { mapState } from "vuex";
import BrowsLayout from "./BrowsLayout.vue";

export default {
	data() {
		return {
			dialogVisible: false
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		previewURL() {
			return this.editStoryData.pdf_list &&
				this.editStoryData.pdf_list.length > 0
				? this.editStoryData.pdf_list[0].url
				: "";
		}
	},
	filters: {
		httpsFilter(val) {
			return val.replace(/^https/, "http");
		},
	},
	methods: {
		transformStoryAccount(val) {
			return val;
			// return val && val.match(/[0-9]+/)[0] || "";
		},
	},
	created() { },
	mounted() { },
	components: {
		BrowsLayout
	}
};
</script>

<style lang="scss" scoped>
.pdf {
	font-size: 14px;

	.tips {
		font-size: 12px;
	}
}
</style>